export * from './physicalExamination.model';
export * from './physicalExamination.service';
export * from './physicalExamination.slice';
